import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BnNgIdleService } from 'bn-ng-idle';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../models';
import { Cliente } from '../models/cliente';
import { AutocolorStore } from '../store/autocolor-store.service.ts.service';
import { AppConfigService } from './config/app.config.service';


@Injectable({ providedIn: 'root' })
export class AccountService {
    private userSubject: BehaviorSubject<User>;
    public user: Observable<User>;
    private isIdle: boolean = false;

    constructor(
        private http: HttpClient,
        private colorStore: AutocolorStore,
        private keycloak: KeycloakService,
        private bnIdle: BnNgIdleService,
        private confServ: AppConfigService
    ) {
        this.userSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
        this.user = this.userSubject.asObservable();
    }

    public get userValue(): User {
        return this.userSubject.value;
    }

    async login(): Promise<void> {

        // api securidad?
        this.http.post<User>(`${this.confServ.getConfig().apiUrl}/users/authenticate`, {})
            .subscribe((user) => {
                localStorage.setItem('user', JSON.stringify(user));
                this.userSubject.next(user);
            });


        this.keycloak.keycloakEvents$.subscribe({
            next: (e) => {
                if (e.type == KeycloakEventType.OnTokenExpired) {
                    console.log('onTokenExpired');
                    if (!this.isIdle) {
                        this.keycloak.updateToken(5);
                    }
                }
            }
        });

        this.bnIdle.startWatching(3600).subscribe((isTimedOut: boolean) => {
            if (isTimedOut) {
                console.log('Is idle');
                this.isIdle = true;
            }
        });

    }

    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('user');
        this.userSubject.next(null);
        this.colorStore.limpiarStore();
        this.keycloak.logout(window.location.origin);
    }

    getById(id: string) {
        return this.http.get<User>(`${this.confServ.getConfig().apiUrl}/users/${id}`);
    }

    cambiarContrasenia(id, params) {
        // api seguridad?
        return this.http.post(`${this.confServ.getConfig().apiUrlMtto}/users/contrasenia`, params);
    }

    getAll() {
        return this.http.get<User[]>(`${this.confServ.getConfig().apiUrlMtto}/users`);
    }

    createUser(user: User) {
        return this.http.post(`${this.confServ.getConfig().apiUrlMtto}/users/register`, user);
    }

    update(id, params) {
        return this.http.put(`${this.confServ.getConfig().apiUrlMtto}/users/${id}`, params)
            .pipe(map(x => {
                // update stored user if the logged in user updated their own record
                if (id == this.userValue.id) {
                    // update local storage
                    const user = { ...this.userValue, ...params };
                    localStorage.setItem('user', JSON.stringify(user));

                    // publish updated user to subscribers
                    this.userSubject.next(user);
                }
                return x;
            }));
    }

    deleteUser(id: string): Observable<boolean> {
        return this.http.delete<boolean>(`${this.confServ.getConfig().apiUrlMtto}/users/${id}`)
            .pipe(map(x => {
                // auto logout if the logged in user deleted their own record
                if (id == this.userValue.id) {
                    this.logout();
                }
                return x;
            }));
    }

    getUsuariosPorPais(idPais: number) {
        const url = `${this.confServ.getConfig().apiUrlMtto}/users/pais/${idPais}`;
        return this.http.get<User[]>(url);
    }

    getUsuariosPorCliente(idCliente: number) {
        const url = `${this.confServ.getConfig().apiUrlMtto}/users/cliente/${idCliente}`;
        return this.http.get<User[]>(url);
    }

    getClientesPorAdmin(idUser: number) {
        const url = `${this.confServ.getConfig().apiUrlMtto}/users/${idUser}/clientes`;
        return this.http.get<Cliente[]>(url);
    }

    addClientesAUsuario(idUser: number, client: Cliente) {
        const url = `${this.confServ.getConfig().apiUrlMtto}/users/${idUser}/clientes`;
        return this.http.post<Cliente>(url, client);
    }

    eliminarCliente(iduser: number, idcliente: number) {
        return this.http.delete<boolean>(`${this.confServ.getConfig().apiUrlMtto}/users/${iduser}/clientes/${idcliente}`);
    }
}